import { inputStyles } from "../styles/styles";

import React, { useState, useEffect } from "react";

import BaseWindow from "./public/BaseWindow";
import {
  Grid,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  FormControl,
  FormHelperText,
} from "@material-ui/core";
import { PhoneNumberMask } from "./public/TextMask";
import { connect } from "react-redux";
import NotFoundPage from "./public/NotFoundPage";
import { TCKNMask } from "./public/TextMask";
import { updateCustomerInfo } from "../store/customerInformation/actions";
import DatePicker from "./public/DatePicker";

function AnonimStep1(props) {
  const classes = inputStyles();
  const inputDataDefaultState = {
    firmaTemsilcisiTckn: {
      value: "",
      error: false,
      helperText: "",
    },
    firmaTemsilcisiPhone: {
      value: "",
      error: false,
      helperText: "",
    },
    firmaTemsilcisiBirthDate: {
      value: new Date(),
      error: false,
      helperText: "",
    },
    kisiselVerilerCheckBox: {
      value: false,
      error: false,
      helperText: "",
    },
  }
  const [inputData, setInputData] = useState(inputDataDefaultState);

  useEffect(() => {
    const listener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        event.preventDefault();
        devamClick();
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, []);

  const inputDataChange = (propName, value, type) => {
    let setVal = value;
    switch (type) {
      case "date":
        setVal = new Date(value);
        break;
      default:
        setVal = value;
        break;
    }
    setInputData((prevState) => {
      return {
        ...prevState,
        [propName]: {
          value: setVal,
          error: prevState[propName].error,
          helperText: prevState[propName].helperText,
        },
      };
    });
  };

  const setInputDataErrorChange = (
    prevState,
    propName,
    equalVal,
    helperText,
    type
  ) => {
    let compairingVal = "";
    switch (type) {
      case "length":
        compairingVal = prevState[propName].value.length;
        break;
      default:
        compairingVal = prevState[propName].value;
        break;
    }

    if (compairingVal !== equalVal) {
      return {
        ...prevState,
        [propName]: {
          value: prevState[propName].value,
          error: true,
          helperText,
        },
      };
    } else {
      return {
        ...prevState,
        [propName]: {
          value: prevState[propName].value,
          error: false,
          helperText: "",
        },
      };
    }
  };

  const validationCheck = () => {
    let valid = true;

    setInputData((prevState) => {
      prevState = setInputDataErrorChange(
        prevState,
        "firmaTemsilcisiTckn",
        11,
        "Lütfen Geçerli Bir T.C. Kimlik Numarası Giriniz!",
        "length"
      );
      prevState = setInputDataErrorChange(
        prevState,
        "firmaTemsilcisiPhone",
        10,
        "Lütfen Geçerli Bir Telefon Numarası Giriniz!",
        "length"
      );
      /*prevState = setInputDataErrorChange(
        prevState,
        "firmaTemsilcisiBirthDate",
        8,
        "Lütfen Geçerli Bir Doğum Tarihi Giriniz!",
        "length"
      );*/
      prevState = setInputDataErrorChange(
        prevState,
        "kisiselVerilerCheckBox",
        true,
        "Kişisel Verilerin Korunması ve İşlenmesi Hakkında Bilgilendirme Metni’ni ve Haklarım dokümanlarını okuyunuz!",
        "checked"
      );

      Object.keys(prevState).forEach((key) => {
        if (prevState[key].error) {
          valid = false;
        }
      });
      return prevState;
    });

    return valid;
  };

  const devamClick = (e) => {
    if (validationCheck()) {
      props.dispatch(
        updateCustomerInfo({
          tckn: inputData.firmaTemsilcisiTckn.value,
          phoneNumber: inputData.firmaTemsilcisiPhone.value,
          birthDate: inputData.firmaTemsilcisiBirthDate.value,
        })
      );
    } else {
      
    }
  };

  const temizleClick = () => {
    setInputData(inputDataDefaultState);
  }

  return props.customerInformations.vkn ? (
    <BaseWindow>
      <div>
        <Grid item xs={12}>
          <p className={classes.p}>Vergi Kimlik Numarası</p>
          <TextField
            className={classes.textField}
            size="small"
            variant="outlined"
            defaultValue={props.customerInformations.vkn}
            disabled
          />
        </Grid>
        <Grid item xs={12}>
          <p className={classes.p}>
            Firma Yasal Temsilcisi T.C. Kimlik Numarası
          </p>
          <TextField
            error={inputData.firmaTemsilcisiTckn.error}
            helperText={inputData.firmaTemsilcisiTckn.helperText}
            value={inputData.firmaTemsilcisiTckn.value}
            onChange={(ev) =>
              inputDataChange("firmaTemsilcisiTckn", ev.target.value)
            }
            className={classes.textField}
            size="small"
            variant="outlined"
            InputProps={{
              inputComponent: TCKNMask,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <p className={classes.p}>Firma Yasal Temsilcisi Cep Telefonu</p>
          <TextField
            error={inputData.firmaTemsilcisiPhone.error}
            helperText={inputData.firmaTemsilcisiPhone.helperText}
            value={inputData.firmaTemsilcisiPhone.value}
            onChange={(ev) =>
              inputDataChange("firmaTemsilcisiPhone", ev.target.value)
            }
            className={classes.textField}
            size="small"
            variant="outlined"
            InputProps={{
              inputComponent: PhoneNumberMask,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <p className={classes.p}>Firma Yasal Temsilcisi Doğum Tarihi</p>
          <DatePicker
            obj={inputData.firmaTemsilcisiBirthDate}
            propName={'firmaTemsilcisiBirthDate'}
            setInputData={setInputData}
            onChange={(date) =>
              inputDataChange("firmaTemsilcisiBirthDate", date, "date")
            }
          />
        </Grid>
        <Grid item xs={12}>
          <FormControl
            required
            error={inputData.kisiselVerilerCheckBox.error}
            component="fieldset"
            className={classes.formControl}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={inputData.kisiselVerilerCheckBox.value}
                  onChange={(ev) =>
                    inputDataChange("kisiselVerilerCheckBox", ev.target.checked)
                  }
                  color={"primary"}
                />
              }
              label={
                <p className={classes.p}>
                  Kişisel Verilerin Korunması ve İşlenmesi Hakkında
                  Bilgilendirme Metni’ni ve Haklarımı okudum.
                </p>
              }
            />
            <FormHelperText>
              {inputData.kisiselVerilerCheckBox.helperText}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid
          container
          justifyContent="flex-end"
          alignItems="flex-end"
          item
          style={{ marginTop: 30 }}
        >
          <Button
            variant="outlined"
            color="primary"
            size="small"
            style={{ marginRight: 10 }}
            onClick = {temizleClick}
          >
            Temizle
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={devamClick}
          >
            Devam
          </Button>
        </Grid>
      </div>
    </BaseWindow>
  ) : (
    <NotFoundPage />
  );
}

const mapStateToProps = (state) => {
  return {
    customerInformations: state.customerInformations,
    alert: state.alert,
  };
};

export default connect(mapStateToProps)(AnonimStep1);
